import { Image, useMediaQuery, Box, Flex } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import SideBar from "./AuthLayout/SideBar";
import Header from "./AuthLayout/Header";

export const AuthLayout = ({ children }) => {
  const [isMobile] = useMediaQuery("(max-width: 991px)");
  const { pathname } = useLocation();

  const isClient = pathname.includes("client");
  const noLayout = pathname.includes("client/kyc");
  return (
    <Box
      color="#000"
      className="no_scroller"
      bg="#FAFAFA"
      fontFamily="Lato"
      h="100vh"
    >
      <Flex justifyContent="center" align="center">
        <Box overflowX="hidden" h="100vh" w="full">
          <Box display={noLayout ? "none" : ""}>{!isMobile && <SideBar />}</Box>
          <Flex
            flexDir="column"
            justifyContent={noLayout ? "center" : "unset"}
            align={noLayout ? "center" : "unset"}
            minH="90vh"
            m={{
              base: "20px",
              md: noLayout ? "20px" : "0 35px 0 290px",
            }}
          >
            <Box
              display={noLayout ? "none" : ""}
              pos="sticky"
              top="0"
              pt="29px"
              bg="#FAFAFA"
              zIndex={333}
            >
              <Header />
            </Box>

            <Box
              borderTopRadius={noLayout ? "32px" : "0"}
              border="1px solid #D6D6D6"
              mb={10}
              borderTop={noLayout ? "1px solid #D6D6D6" : "none"}
              overflow="auto"
              mt={noLayout ? "50px" : "0"}
              w={{ base: "full", lg: noLayout ? "1250px" : "100%" }}
              className="no_scroller"
            >
              <Box
                color="#0F172A"
                borderBottom="1px solid #D6D6D6"
                display={noLayout ? "" : "none"}
                py="30px"
                px={isMobile ? "20px" : "44px"}
                fontSize={{ base: "16px", md: "24px" }}
                lineHeight={{ base: "20px", md: "30px" }}
                fontWeight={700}
              >
                Client KYC
              </Box>
              <Box
                w="100%"
                pt={
                  isMobile
                    ? "20px"
                    : isClient & (pathname === "/client/dashboard")
                      ? "0"
                      : "40px"
                }
                px={{
                  base: "20px",
                  md:
                    isClient & (pathname === "/client/dashboard")
                      ? "0"
                      : "44px",
                }}
                color="#828282"
                pb={10}
                minH="75vh"
              >
                {children}
              </Box>
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};

export const NonAuthLayout = ({ children }) => {
  return (
    <Flex
      flexDir="column"
      pos="relative"
      align="center"
      justifyContent="center"
      fontFamily="Lato"
      minH="100vh"
      w="full"
      color="#010725"
    >
      <Image
        src="/assets/bgg.png"
        pos="absolute"
        w="full"
        h="full"
        top="0"
        left="0"
      />

      <Flex
        px={{ base: "20px", md: "unset" }}
        overflow="hidden"
        pos="relative"
        w={{ base: "full", md: "full", lg: "1250px" }}
        h="100vh"
        justifyContent="center"
        align="center"
      >
        <Flex
          w={{ base: "100%", md: "50%" }}
          overflowY="scroll"
          h={{ base: "90vh", md: "90vh", "2xl": "75vh" }}
          flexDir="column"
          bg="#FFFFFF75"
          backdropFilter="blur(10px)"
          borderRadius="24px"
          p={{ base: "20px", md: "50px 40px" }}
        >
          <Image
            src="/assets/logo.png"
            w={{ base: "200px", "2xl": "275px" }}
            h={{ base: "45px", "2xl": "64px" }}
            mb={{ base: "30px", "2xl": "40px" }}
          />
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};
